const state = {
    selectedStock: null, //stores the selected client(used in form modal)
    showFormStock: null,
    stockShow: false, //show=true | edit=false
    showStockModal: null,
};

const getters = {
    getSelectedStock(state){
        return state.selectedStock;
    },
    getShowStockModal(state){
        return state.showStockModal;
    },
    getStockShow(state){
        return state.stockShow;
    },

};

const mutations = {
    setSelectedStock(state, payload){ //this also works for new article
        state.selectedStock = payload;
    },
    setShowStockModal(state, payload){ //this also works for new article
        state.showStockModal = payload;
    },
    setStockShow(state, payload){ //this also works for new article
        state.stockShow = payload;
    },
};

const actions = {
    setSelectedStock( {commit}, payload){
        commit('setSelectedStock', payload);
    },
    setShowStockModal({commit}, payload){
        commit('setShowStockModal', payload);
    },
    setStockShow({commit}, payload){
        commit('setStockShow', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};